import { OAuthConsentPage } from '@/containers/integrations/oauth-consent-page.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/oauth-consent')({
  component: OAuthConsentPage,
});
